import { render, staticRenderFns } from "./ContentsTable.vue?vue&type=template&id=cefc8800&scoped=true"
import script from "./ContentsTable.vue?vue&type=script&lang=js"
export * from "./ContentsTable.vue?vue&type=script&lang=js"
import style0 from "./ContentsTable.vue?vue&type=style&index=0&id=cefc8800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefc8800",
  null
  
)

export default component.exports